/**
 * Applies the offer picker's filter row to the offer list. Pulled out so
 * BinomOfferPicker stays inside the per-file size budget.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { BinomOffer } from '@/hooks/binom';

import { sortByIdDesc } from './sort-by-id-desc';

export interface OfferFilterArgs {
  list: BinomOffer[];
  excludeIds: string[];
  groupUuid: string;
  country: string;
  networkId: string;
}

export function filterOfferRows(args: OfferFilterArgs): BinomOffer[] {
  const filtered = args.list
    .filter((o) => !args.excludeIds.includes(o.id))
    .filter(
      (o) =>
        !args.groupUuid ||
        (o as { groupUuid?: string }).groupUuid === args.groupUuid,
    )
    .filter((o) => !args.country || o.countryCode === args.country)
    .filter((o) => !args.networkId || matchesNetwork(o, args.networkId));
  return sortByIdDesc(filtered);
}

function matchesNetwork(o: BinomOffer, networkId: string): boolean {
  const v = (o as { affiliateNetworkId?: number | string }).affiliateNetworkId;
  return String(v ?? '') === networkId;
}
